module.exports = __webpack_public_path__ + "static/media/projects-end.e14ef799.svg";